import { makeVar } from '@apollo/client';
import type { VideoAgreementIdentityVerificationDialogVar } from './VideoAgreementIdentityVerificationDialog.types';

const videoAgreementIdentityVerificationDialogVarDefault: VideoAgreementIdentityVerificationDialogVar =
  {
    open: false,
    stepNumber: 0,
    stepNumberLabel: '',
    verificationId: '',
    textToRead: '',
    videoRecorded: null,
    showDialogTitle: true,
    errorMessage: '',
    onFinish: () => {},
    onClose: () => {},
  };

export const videoAgreementIdentityVerificationDialogVar = makeVar(
  videoAgreementIdentityVerificationDialogVarDefault,
);

export const resetVideoAgreementIdentityVerificationDialogVar = () => {
  videoAgreementIdentityVerificationDialogVar(
    videoAgreementIdentityVerificationDialogVarDefault,
  );
};

export const setVideoAgreementIdentityVerificationDialogVar = (
  input: Partial<VideoAgreementIdentityVerificationDialogVar>,
) => {
  videoAgreementIdentityVerificationDialogVar({
    ...videoAgreementIdentityVerificationDialogVar(),
    ...input,
  });
};
